import { render } from "./Hall7En.vue?vue&type=template&id=6f3bff49"
import script from "./Hall7En.vue?vue&type=script&lang=js"
export * from "./Hall7En.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__